import he from "he"; // to remov special characters

export function decodeHtmlEntities(str) {
  try {
    if (
      typeof document === "undefined" ||
      document === "undefined" ||
      !document
    ) {
      return str;
    }
    var textArea = document?.createElement("textarea");
    textArea.innerHTML = str;
    return textArea?.value ?? str;
  } catch (err) {
    console.error(err);
    return str;
  }
}

export function decodeHtmlEntitiesSSR(str) {
  try {
    let text = str.replace(/<[^>]*>?/gm, ""); // Remove HTML tags
    text = he.decode(text); // Decode HTML entities
    return text ?? str;
  } catch (err) {
    console.error(err);
    return str;
  }
}
